import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import pub from '../i18n/publicTranslations';

export default function PublicFooter() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const pt = (key) => {
    const e = pub[key];
    if (!e) return key;
    return e[language === 'es' ? 1 : language === 'fr' ? 2 : 0] || e[0];
  };

  return (
    <footer className="py-10 px-6 bg-[#080D19] border-t border-white/5 relative z-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <img src="/assets/trackmypackage-logo.png" alt="Track My Package" className="h-12" />
        <div className="flex flex-wrap gap-6 text-sm text-gray-500">
          <button onClick={() => navigate('/')} className="hover:text-white transition-colors">{pt('nav.home')}</button>
          <button onClick={() => navigate('/features')} className="hover:text-white transition-colors">{pt('nav.features')}</button>
          <button onClick={() => navigate('/pricing')} className="hover:text-white transition-colors">{pt('nav.pricing')}</button>
          <button onClick={() => navigate('/blog')} className="hover:text-white transition-colors">{pt('nav.blog')}</button>
          <button onClick={() => navigate('/track-package')} className="hover:text-white transition-colors">{pt('nav.track')}</button>
          <button onClick={() => navigate('/about')} className="hover:text-white transition-colors">{pt('nav.about')}</button>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-4 pt-4 border-t border-white/5 text-center">
        <p className="text-gray-600 text-xs">Track My Package — {pt('footer.tagline')}</p>
        <p className="text-gray-600 text-[11px] mt-2">
          Website Created by{' '}
          <a
            href="https://www.GregMiceli.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white underline-offset-2 hover:underline transition-colors"
            data-testid="credit-greg-miceli"
          >
            www.GregMiceli.com
          </a>
        </p>
      </div>
    </footer>
  );
}
